import { env } from "@/@configs/env";

export const Api = {
	EdupassApi: env.get("VITE_EDUPASS_API"),
	EduplayApi: `${env.get("VITE_EDUPASS_WITHOUT_API_PREFIX_API")}/eduplay`,
	MediaUrl: env.get("VITE_MEDIA_URL"),
};

export const LocalStorage = {
	RedirectAfterLogin: "redirect_after_login",
};

export const ExternalUrls = {
	Support:
		"https://api.whatsapp.com/send/?phone=5511987566079&text&type=phone_number&app_absent=0",
	GalenaService: "https://atendimento.galena.com/hc/pt-br",
	LookerDashboard:
		"https://lookerstudio.google.com/embed/reporting/00d8be71-428a-4f7c-94dc-7873dcb7829a/page/p_szhuuo2knd",
	MockedLookerDashboard:
		"https://lookerstudio.google.com/embed/reporting/8c12c5af-893b-46e6-b4e9-53c491059511/page/p_ydtreq2xhd",
	WhatsappUrl: "https://wa.me/5511987566079",
	ReferralLink: "https://lp.galena.com/indicacao",
};

export const info = {
	EduplayId: 75,
};

export const SUPPORT_EMAIL = "atendimento@galena.com";
